export default function (filter) {
    let selector = '[data-tag]';
    if (typeof filter !== 'undefined' && filter) {
        selector = filter + selector;
    }
    const tagItems = document.querySelectorAll(selector);
    if (typeof tagItems.length == 'undefined') {
        return;
    }
    for (let i = 0, len = tagItems.length; i < len; i++) {
        if (typeof tagItems[i] !== 'undefined') {
            tagItems[i].addEventListener('click', function (e) {
                // e.preventDefault();
                dataLayer.push({
                    'event': 'trackEvent',
                    'eventCategory': getAttribute(this, 'tag'),
                    'eventAction': getAttribute(this, 'action'),
                    'eventLabel': getAttribute(this, 'label'),
                    'eventValue': getAttribute(this, 'value'),
                });
            });
        }
    }

    function getAttribute(e, a) {
        if (typeof e == 'undefined' || typeof e.dataset == 'undefined' || typeof e.dataset[a] == 'undefined') {
            return '';
        }
        return e.dataset[a];
    }
};


// WEBPACK FOOTER //
// ./resources/assets/js/modules/analyticsTagging.js